import { AuthorizedBaseAxios, flatten } from 'core/axios/axios';
import { ProfileOwnerDTO, UserSettingsDTO } from 'models/user';
import { pipe } from 'ramda';

import { DoctorDTO } from 'models/doctor';
import { PageParams, PageWrapperDTO } from 'models/page';
import { MfaConfigDTO, MfaVerificationDto } from 'models/mfa';
import { unwrap, ListWrapper } from '@summer/react-kit';

const managementUrl = '/api/management';
const usersResUrl = '/api/users';
const usersMfaResUrl = '/api/users/mfa';

const fetchDoctors = (params: PageParams) =>
  AuthorizedBaseAxios.get<PageWrapperDTO<DoctorDTO>>(
    `${managementUrl}/doctors`,
    { params }
  ).then(pipe(flatten));

const deleteDoctor = ({ userId }: { userId: number }) =>
  AuthorizedBaseAxios.delete(`${usersResUrl}/doctors/${userId}`);

const fetchProfileOwners = (params: PageParams) =>
  AuthorizedBaseAxios.get<PageWrapperDTO<ProfileOwnerDTO>>(
    `${managementUrl}/users`,
    { params }
  ).then(pipe(flatten));

const deleteProfileOwner = ({ userId }: { userId: number }) =>
  AuthorizedBaseAxios.delete(`${managementUrl}/users/${userId}`);

const activateUser = (userId: number) =>
  AuthorizedBaseAxios.post(`${usersResUrl}/${userId}/activate`).then(
    pipe(flatten)
  );

const deactivateUser = (userId: number) =>
  AuthorizedBaseAxios.post(`${usersResUrl}/${userId}/deactivate`).then(
    pipe(flatten)
  );

const fetchPatients = (params: PageParams) =>
  AuthorizedBaseAxios.get<PageWrapperDTO<ProfileOwnerDTO>>(
    `${managementUrl}/patients`,
    { params }
  ).then(pipe(flatten));

const deletePatient = ({ id }: { id: number }) =>
  AuthorizedBaseAxios.delete(`${managementUrl}/patients/${id}`);

const enableMfa = () =>
  AuthorizedBaseAxios.post<MfaConfigDTO>(`${usersMfaResUrl}/enable`).then(
    pipe(flatten)
  );

const verifyMfaConfig = (body: MfaVerificationDto) =>
  AuthorizedBaseAxios.post(`${usersMfaResUrl}/verify`, body);

const getMfaData = () =>
  AuthorizedBaseAxios.get(`${usersMfaResUrl}/enable/code`);

const getUserSettings = () =>
  AuthorizedBaseAxios.get<ListWrapper<UserSettingsDTO>>(
    `${usersResUrl}/settings`
  ).then(pipe(flatten, unwrap));

const setUserLanguage = (languageCode: string) =>
  AuthorizedBaseAxios.put(`${usersResUrl}/language`, { languageCode });

export const UsersAPI = {
  fetchDoctors,
  deleteDoctor,

  fetchProfileOwners,
  deleteProfileOwner,

  activateUser,
  deactivateUser,

  fetchPatients,
  deletePatient,

  enableMfa,
  verifyMfaConfig,
  getMfaData,

  getUserSettings,
  setUserLanguage,
};
